import { useQuery } from '@tanstack/react-query';
import { fetchBalanceSheet } from './api';

export const balanceSheetKeys = {
  all: ['balance-sheet'] as const,
  asOf: (asOf: string) => [...balanceSheetKeys.all, 'asOf', asOf] as const,
};

export function useBalanceSheet(asOf: string, enabled = true) {
  return useQuery({
    queryKey: balanceSheetKeys.asOf(asOf),
    queryFn: () => fetchBalanceSheet(asOf),
    enabled: enabled && !!asOf,
    staleTime: 1000 * 60 * 5,
  });
}
